(function ($) {
    $.fn.notification = function (options) {
        return this.each(function () {
            const self = $(this);
            if( self.data( 'notification' ) !== 'active' ) {
                self.data( 'notification', 'active' );

                let notificationTimeout;

                function closeFavoriteNotification() {
					notificationTimeout	= setTimeout(function(){
                        $('.notification').remodal().close();
                        self.data( 'notification', null );
                    }, 2000);
                }

                closeFavoriteNotification();

                self.on('focusin.notification mouseenter.notification', function(){
                    clearTimeout( notificationTimeout );
                }).on('focusout.notification mouseleave.notification', closeFavoriteNotification );
            }
        });
    }
})(jQuery);
